module.exports = __webpack_public_path__ + "static/media/Infra-ExtraBold.eaa46bb1.otf";